<template>
  <section class="content-plans">
    <div class="content-plans-itens">
      <Breadcrumb :links="links" />
      <div class="content-plans-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3">
            <router-link
              tag="a"
              :to="{ name: 'RegisterTargetAudience' }"
              class="content--card-register"
              style="min-height: 200px"
            >
              <img
                class="img-fluid"
                src="@/assets/img/image-plus.png"
                alt="image plus"
                title="image plus"
              />
            </router-link>
          </div>
          <template v-if="hasTargetAudience">
            <div
              class="col-12 col-sm-6 col-lg-6 col-xl-4 col-xl-3"
              v-for="target in targetAudience"
              :key="target.id"
            >
              <CardTargetAudience :target="target" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import CardTargetAudience from "@/views/Professional/components/CardTargetAudience";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Profissional",
          routerName: "Professional",
        },
        {
          name: "Listar Públicos Alvo",
          routerName: "ListTargetAudience",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      targetAudience: "Professional/targetAudience",
    }),
    hasTargetAudience() {
      return (
        this.targetAudience &&
        Array.isArray(this.targetAudience) &&
        this.targetAudience.length > 0
      );
    },
  },
  components: {
    Breadcrumb,
    CardTargetAudience,
  },
  methods: {
    ...mapActions("Professional", ["consultTargetAudience"]),
  },
  mounted() {
    this.consultTargetAudience();
  },
};
</script>
